import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { MessageEventKind } from "../../../define/MessageEventKind";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { NormalBackpackType } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import { openOreEndInterface, OpenOreSpecialCollect, openOreStartInterface } from "./openOreConst";
import openOreGameObj from "./openOreGameObj";

const {ccclass, property} = cc._decorator;

@ccclass
export default class openOreGameClean extends cc.Component {

    @property({ type: cc.Node, displayName:'' })
    btnPushBackpack: cc.Node = null;

    @property({type:cc.SpriteFrame,displayName:"盈亏图片"})
    profitLossSps:cc.SpriteFrame[] = [];

    @property({type:cc.Node,displayName:"光效节点"})
    lightNode:cc.Node = null;

    @property({type:cc.Node,displayName:"盈亏节点"})
    profitLossNode:cc.Node = null;

    @property({type:cc.Label,displayName:"名字文本"})
    lbName:cc.Label = null;

    @property({type:cc.Label,displayName:"估价文本"})
    lbPrice:cc.Label = null;

    @property({type:cc.Label,displayName:"描述文本"})
    lbExplain:cc.Label = null;

    @property({type:cc.Node,displayName:"top节点"})
    topNode:cc.Node = null;

    openEndInterface:openOreEndInterface = null;

    startInterface:openOreStartInterface = null;

    openOreNode:cc.Node = null;

    openPage:cc.Node = null;

    oreScript:openOreGameObj = null;

    private sellPrice = 0;

    bindData(startInterface:openOreStartInterface,openEndInterface:openOreEndInterface,openOreNode:cc.Node,openPage:cc.Node){
        this.openEndInterface = openEndInterface;
        // this.openEndInterface.price = Math.floor( NormalGameManager._instance.getPriceRate() * this.openEndInterface.price );
        this.startInterface = startInterface;
        this.openOreNode = openOreNode;
        this.oreScript = openOreNode.getComponent(openOreGameObj);
        openOreNode.setParent(this.topNode);
        openOreNode.setPosition(0,-150);
        this.openPage = openPage;
    }

    onLoad(){
        let tween = cc.tween(this.lightNode).by(2.5,{angle:360}).call(()=>{
            this.lightNode.angle = 0;
        }).start();
        cc.tween(this.lightNode).repeatForever(tween).start();
        this.updatePage();
    }

    updatePage(){
        let bShowBp = false;

        let price:number = this.openEndInterface.price;
        let buyPrice:number = this.startInterface.price;

        let strTitle = this.startInterface.stoneName;
        let describe = this.openEndInterface.describe;
        let backpackId:number = this.oreScript.openObjId;
        if(backpackId!=null){
            O1HD.getManagers().soundMgr.playSound("openTreasure").then();
            let backpackConfig = backPackEventMap()[backpackId];
            bShowBp = backpackConfig.type && backpackConfig.type.includes(NormalBackpackType.NVWA_STORE);
            let bPushBp = false;
            if (bShowBp) {
                price = backpackConfig.sellPrice;   
                bPushBp = false;
                describe = backpackConfig.details;
                strTitle = backpackConfig.name;
            }
            
            if (bPushBp) {
                NormalGameManager._instance.onPushGoods(backpackId,1);
                O1HD.getModules().uiControlModule.showMessageBox(`已将${backpackConfig.name}放入背包`);
            }
        }

        this.btnPushBackpack.active = bShowBp;
        this.sellPrice = price;
        this.lbPrice.string = data_control.getNumberFormat(price);
        this.lbName.string = strTitle;
        if(buyPrice < price){
            // 赢
            this.profitLossNode.getComponent(cc.Sprite).spriteFrame = this.profitLossSps[1];
            this.lightNode.active = true;
        }else{
            // 亏
            this.profitLossNode.getComponent(cc.Sprite).spriteFrame = this.profitLossSps[0];
            this.lightNode.active = false;

            if (bShowBp) {
                cc.log('--出错了');
            }
        }
        this.showExplain(describe);
    }

    async showExplain(describe: string){
        let explain:string = describe;
        let str:string = "";
        for(let i = 0;i<explain.length;i++){
            let s = explain[i];
            str += s;
            this.lbExplain.string = str;
            await new Promise<void>(resolve=>{
                this.scheduleOnce(resolve,0.02);
            });
        }
    }

    onBtnSell(event: cc.Event.EventTouch){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.doSell(event.target);
    }

    doSell(node: cc.Node, scale: number = 1) {
        let price:number = this.sellPrice * scale;
        O1HD.getServices().userSrv.setCoins(price,true, node);
        this.openPage && this.openPage.destroy();
        this.openPage && this.openPage.removeFromParent();
        this.closeThis();
    }

    onClickDoubleSell(event: cc.Event.EventTouch) {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.doSell(event.target, 2);
        },()=>{

        },null,"切矿石第二刀观看视频双倍卖出");
    }

    onClickPushBackpack() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        let backpackId:number = this.oreScript.openObjId;
        if(backpackId!=null){
            let backpackConfig = backPackEventMap()[backpackId];
            let bShowBp = backpackConfig.type && backpackConfig.type.includes(NormalBackpackType.NVWA_STORE);
            let bPushBp = true;
            if (bShowBp) {
                let t = OpenOreSpecialCollect;
                let nidx = t.indexOf(backpackId);
                let gameData = NormalGameManager._instance.getGameData();
                if (nidx != -1) {
                    if (!gameData.nvWaStore[nidx]) {
                        gameData.nvWaStore[nidx] = true;
                        bPushBp = false;
                        NormalGameManager._instance.writeGameData();

                        let pPos = this.btnPushBackpack.convertToWorldSpaceAR(cc.v2());
                        O1HD.emit(MessageEventKind.EventName.NVWA_STORE_COLLECT_ANI, nidx, pPos);
                    }
                }
            }
            if (bPushBp) {
                NormalGameManager._instance.onPushGoods(backpackId,1);
            }
        }

        this.openPage && this.openPage.destroy();
        this.openPage && this.openPage.removeFromParent();
        this.closeThis();
    }

    closeThis(){
        this.node.destroy();
        this.node.removeFromParent();
    }

}
